/* eslint-disable react/prop-types -- usando TypeScript para tipar as props */

import { Box, Flex, Heading, Icon, Text, VStack } from '@chakra-ui/react'
import { CreditCard } from 'lucide-react'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { PaymentMethod, PaymentMethodsCardProps } from '../interfaces/dashboard.interface'

export const PaymentMethodsCard: React.FC<PaymentMethodsCardProps> = ({
  data,
  headerBgColor,
  gridStroke,
  axisStroke,
}) => {
  const formatCurrency = (value: number) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)

  return (
    <Box p={6} borderWidth="1px" borderRadius="lg" bg={headerBgColor}>
      <Heading as="h3" size="md" mb={4} display="flex" alignItems="center" gap={2}>
        <Icon as={CreditCard} /> Formas de Pagamento
      </Heading>

      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data ?? []} layout="vertical">
          <CartesianGrid strokeDasharray="3 3" stroke={gridStroke} />
          <XAxis type="number" stroke={axisStroke} />
          <YAxis dataKey="method" type="category" stroke={axisStroke} />
          <Tooltip formatter={(value: number) => `${value.toFixed(0)}%`} />
          <Bar dataKey="percentage" fill="#4299E1" radius={[0, 4, 4, 0]} />
        </BarChart>
      </ResponsiveContainer>

      <VStack spacing={2} mt={4}>
        {(data ?? []).map((method, idx) => (
          <Flex key={idx} justifyContent="space-between" w="100%" fontSize="sm">
            <Text color="gray.500">{method.method}</Text>
            <Text fontWeight="medium">{formatCurrency(method.value)}</Text>
          </Flex>
        ))}
      </VStack>
    </Box>
  )
}
